/* eslint-disable react/static-property-placement */
export default class RestrictionArea {
  constructor(restrictionAreaData) {
    if (typeof restrictionAreaData.id !== 'string') {
      throw new Error('RestrictionArea: incorrect id');
    }
    if (typeof restrictionAreaData.displayName !== 'string') {
      throw new Error('RestrictionArea: incorrect displayName');
    }
    if (typeof restrictionAreaData.dealerId !== 'string') {
      throw new Error('RestrictionArea: incorrect dealerId');
    }

    if (!restrictionAreaData.geoJson) {
      throw new Error('RestrictionArea: incorrect geoJson');
    }

    Object.assign(this, restrictionAreaData);
  }

  id = null;

  displayName = null;

  dealerId = null;

  geoJson = null;

  mapUrl = null;
}



// WEBPACK FOOTER //
// ./src/models/RestrictionArea.js